import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Formats from "@/pages/Formats";
import Playground from "@/pages/Playground";
import Extension from "@/pages/Extension";
import History from "@/pages/History";
import Autopilot from "@/pages/Autopilot";
import Styles from "@/pages/Styles";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import { TOKEN_KEY } from "@/lib/api";

const Protected = () => (localStorage.getItem(TOKEN_KEY) ? <Layout /> : <Navigate to="/login" replace />);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Protected />}>
          <Route path="/account" element={<Account />} />
          <Route path="/autopilot" element={<Autopilot />} />
          <Route path="/styles" element={<Styles />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/products" element={<Products />} />
          <Route path="/formats" element={<Formats />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/extension" element={<Extension />} />
          <Route path="/history" element={<History />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
